/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rmf_Degraded_Retry_ButtonInputs */

const en_rmf_degraded_retry_button = /** @type {(inputs: Rmf_Degraded_Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry RMF startup`)
};

const fr_rmf_degraded_retry_button = /** @type {(inputs: Rmf_Degraded_Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relancer le chargement RMF`)
};

const ms_sg2_rmf_degraded_retry_button = /** @type {(inputs: Rmf_Degraded_Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuba semula permulaan RMF`)
};

/**
* | output |
* | --- |
* | "Retry RMF startup" |
*
* @param {Rmf_Degraded_Retry_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const rmf_degraded_retry_button = /** @type {((inputs?: Rmf_Degraded_Retry_ButtonInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rmf_Degraded_Retry_ButtonInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rmf_degraded_retry_button(inputs)
	if (locale === "fr") return fr_rmf_degraded_retry_button(inputs)
	return ms_sg2_rmf_degraded_retry_button(inputs)
});